export default __webpack_public_path__ + "static/media/B_wdt_c_cap_2.329aec74.mp3";